import { render, staticRenderFns } from "./memberLayout.vue?vue&type=template&id=05f04108&scoped=true"
import script from "./memberLayout.vue?vue&type=script&lang=js"
export * from "./memberLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f04108",
  null
  
)

export default component.exports